// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main_row {
  height: 100%;
}
.main_row .category_col {
  background: #F3F3F3;
}
.main_row .category_col .category_item {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 10px 5px 10px 10px;
  margin-top: 1.5px;
  background: #F3F3F3;
  border-radius: 0px;
  transition: all 0.3s;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  border-bottom: 1.5px solid rgba(79, 97, 79, 0.1019607843);
}
.main_row .category_col .category_item ion-img {
  width: 60px;
  margin-right: 10px;
}
.main_row .category_col .category_item h3 {
  font-family: AppFontBold, sans-serif;
  font-size: 14px;
  color: var(--ion-color-secondary);
}
.main_row .category_col .category_item:first-of-type {
  margin-top: 0px;
}
.main_row .category_col .category_item.selected {
  background: var(--ion-color-primary);
  color: #fff;
}
.main_row .category_col .category_item.selected h3 {
  color: white;
}
.main_row .border_top_line {
  width: 100%;
  height: 3px;
  background: #d9d9d9;
}
.main_row .category_name {
  font-family: AppFontMedium;
  font-size: 17px;
  letter-spacing: 0em;
  text-align: left;
  padding: 30px 0px 20px 7px;
}
.main_row .item_row {
  margin: 0 10px;
}
.main_row .catalog_col {
  position: relative;
  overflow: hidden;
  padding-top: 0;
}

.search_col {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.search_col ion-searchbar {
  --box-shadow: 0px 0px 42px 0px #00000012;
  --border-radius: 10px;
}
.search_col .open_filters {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 42px;
  height: 42px;
  border-radius: 10px;
  box-shadow: 0px 0px 42px 0px rgba(0, 0, 0, 0.0705882353);
}
.search_col .open_filters ion-icon {
  zoom: 1.3;
}

.order_basket_block {
  position: absolute;
  z-index: 20;
  height: 99%;
  width: 450px;
  background: #fbfbfb;
  right: -450px;
  top: -1px;
  transition: right 0.3s;
}
.order_basket_block.open {
  right: 0;
  box-shadow: -26px 11px 79px -10px rgb(149, 149, 149);
}
.order_basket_block .order_basket_header .close_basket_col {
  display: flex;
  justify-content: center;
  align-items: center;
  background: transparent;
  padding-left: 20px;
  font-family: AppFont;
  font-size: 14px;
  letter-spacing: 0em;
  color: var(--ion-color-black);
  background: #f9f9f9;
}
.order_basket_block .order_basket_header .close_basket_img_col {
  display: flex;
  justify-content: center;
  align-items: center;
  background: #d9d9d9;
  padding: 0 16.5px;
  height: 55px;
  width: 55px !important;
}
.order_basket_block .order_basket_header .close_basket_img_col .close_basket_img {
  height: 14px;
  width: 14px;
}

.footer-btn-desktop {
  position: absolute;
  bottom: 35px;
  left: 50%;
  transform: translateX(-50%);
  width: 40%;
  text-align: center;
  display: flex;
  justify-content: center;
}
.footer-btn-desktop ion-button {
  width: 100%;
}

.order_basket_block {
  position: absolute;
  z-index: 20;
  height: 99%;
  width: 450px;
  background: #fbfbfb;
  right: -450px;
  top: -1px;
  transition: right 0.3s;
}
.order_basket_block.open {
  right: 0;
  box-shadow: -26px 11px 79px -10px rgb(149, 149, 149);
}
.order_basket_block .order_basket_header .close_basket_col {
  display: flex;
  justify-content: center;
  align-items: center;
  background: transparent;
  padding-left: 20px;
  font-family: AppFont;
  font-size: 14px;
  letter-spacing: 0em;
  color: var(--ion-color-black);
  background: #f9f9f9;
}
.order_basket_block .order_basket_header .close_basket_img_col {
  display: flex;
  justify-content: center;
  align-items: center;
  background: #d9d9d9;
  padding: 0 16.5px;
  height: 55px;
  width: 55px !important;
}
.order_basket_block .order_basket_header .close_basket_img_col .close_basket_img {
  height: 14px;
  width: 14px;
}

.order_list_row {
  height: 100%;
  display: flex;
}
.order_list_row app-order-content {
  width: 100%;
}

.category-list {
  display: flex;
  overflow: auto;
  scroll-behavior: smooth;
  -ms-overflow-style: none;
  padding: 10px 0px 0px 10px;
  scrollbar-width: none; /* Firefox */
}
@media (min-width: 991px) {
  .category-list {
    height: 90px;
    flex-grow: 1;
  }
  .category-list > ion-chip {
    overflow: unset;
    display: flex;
    flex-grow: 1 !important;
    padding: 12px 16px;
  }
}
.category-list::-webkit-scrollbar {
  display: none;
}
.category-list .category {
  flex: 0 0 auto;
  margin: 8px 3px;
  height: auto;
}
.category-list .category:first-child {
  margin-left: 0px;
}
.category-list .category:last-child {
  margin-right: 15px;
}
.category-list ion-chip {
  --background: transparent;
  border-radius: 16px;
  background: white;
  transition: 200ms linear;
  min-width: 104px;
  border: 1.5px solid var(--ion-color-primary);
  padding: 10px 8px;
  min-height: 54px;
  justify-content: center;
}
.category-list ion-chip p {
  font-family: AppFontBold, sans-serif !important;
  font-size: 16px;
  line-height: 14px;
  margin: 0;
  color: var(--ion-color-secondary);
  word-break: break-word;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-top: 0px;
  margin-bottom: 0px;
  text-align: center;
}
.category-list ion-chip ion-icon,
.category-list ion-chip ion-img {
  height: 31px;
  width: 31px;
  margin-right: 5px;
}
.category-list ion-chip.selected {
  transition: 200ms linear;
  background: var(--ion-color-primary);
}
.category-list ion-chip.selected p {
  color: white;
}
.category-list ion-chip.selected ion-icon {
  fill: var(--ion-color-primary);
}

.more {
  min-height: 100px !important;
  width: 100%;
}
@media (max-width: 992px) {
  .more {
    min-height: 250px !important;
    width: 100%;
  }
}

.venue_info_block {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 20px 20px 0px;
}
.venue_info_block ion-icon {
  zoom: 1.2;
}
.venue_info_block div h3 {
  font-size: 16px;
  color: var(--ion-color-secondary);
  text-transform: capitalize;
}
.venue_info_block div p {
  color: var(--ion-color-secondary);
  font-size: 14px;
  padding-top: 5px;
}

.filters_section {
  z-index: 99;
  position: absolute;
  bottom: 0px;
  left: 0px;
  right: 0px;
  background: white;
  min-height: 0px;
  opacity: 0;
  z-index: -1;
  transition: min-height 0.3s ease-in-out, opacity 0.3s ease-in-out;
  box-shadow: 0px 0px 20px 0px rgba(79, 97, 79, 0.1490196078);
  border-top-right-radius: 16px;
  border-top-left-radius: 16px;
}
.filters_section.show-filters {
  z-index: 999;
  opacity: 1;
  min-height: 200px;
}

.filter-toggle {
  display: flex;
  justify-content: center;
  padding: 12px 0px;
}

.no_items {
  width: 100%;
  height: 70vh;
  display: flex;
  justify-content: center;
  align-items: center;
}

.bsg-category-nav button {
  width: 100%;
}

.item-for-showing {
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
}
.item-for-showing ion-img {
  max-width: 50px;
  max-height: 50px;
}
.item-for-showing.selected {
  color: var(--ion-color-primary);
}`, "",{"version":3,"sources":["webpack://./src/app/pages/menu/menu.page.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AAIA;EACC,YAAA;AAHD;AASC;EACC,mBAAA;AAPF;AAQG;EACD,aAAA;EACA,2BAAA;EACA,mBAAA;EACA,2BAAA;EACA,iBAAA;EAIA,mBAAA;EACA,kBAAA;EAEA,oBAAA;EACA,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,yDAAA;AAVF;AAWE;EACC,WAAA;EACA,kBAAA;AATH;AAWE;EACC,oCAAA;EACA,eAAA;EACA,iCAAA;AATH;AAYE;EACE,eAAA;AAVJ;AAaE;EACE,oCAAA;EACA,WAAA;AAXJ;AAYI;EACD,YAAA;AAVH;AAeC;EACE,WAAA;EACA,WAAA;EACA,mBAAA;AAbH;AAeC;EACE,0BAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EAEA,0BAAA;AAdH;AAiBC;EACE,cAAA;AAfH;AAkBC;EACE,kBAAA;EACA,gBAAA;EACA,cAAA;AAhBH;;AAsBA;EACC,WAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AAnBD;AAoBC;EAEC,wCAAA;EACA,qBAAA;AAnBF;AAqBC;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,wDAAA;AAnBF;AAoBE;EACC,SAAA;AAlBH;;AAwBA;EACC,kBAAA;EACA,WAAA;EACA,WAAA;EAEA,YA3G0B;EA4G1B,mBAAA;EAGA,aAAA;EACA,SAAA;EAEA,sBAAA;AAzBD;AA2BC;EACE,QAAA;EAGA,oDAAA;AAzBH;AA6BG;EACD,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EAEA,oBAAA;EACA,eAAA;EACA,mBAAA;EACA,6BAAA;EACA,mBAAA;AA5BF;AA+BG;EACD,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,iBAAA;EACA,YAAA;EACA,sBAAA;AA7BF;AA8BE;EACE,YAAA;EACA,WAAA;AA5BJ;;AAmCE;EACD,kBAAA;EACA,YAAA;EACA,SAAA;EACA,2BAAA;EACA,UAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;AAhCD;AAiCC;EACE,WAAA;AA/BH;;AAkCE;EACD,kBAAA;EACA,WAAA;EACA,WAAA;EAEA,YA7K0B;EA8K1B,mBAAA;EAGA,aAAA;EACA,SAAA;EAEA,sBAAA;AAnCD;AAqCC;EACE,QAAA;EAGA,oDAAA;AAnCH;AAuCG;EACD,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EAEA,oBAAA;EACA,eAAA;EACA,mBAAA;EACA,6BAAA;EACA,mBAAA;AAtCF;AAyCG;EACD,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,iBAAA;EACA,YAAA;EACA,sBAAA;AAvCF;AAwCE;EACE,YAAA;EACA,WAAA;AAtCJ;;AA2CE;EACD,YAAA;EACA,aAAA;AAxCD;AAyCC;EACC,WAAA;AAvCF;;AA0CE;EACD,aAAA;EACA,cAAA;EACA,uBAAA;EACA,wBAAA;EACA,0BAAA;EACA,qBAAA,EAAA,YAAA;AAvCD;ACnME;EDoOA;IAQA,YAAA;IACA,YAAA;EArCA;EAsCA;IACC,eAAA;IACA,aAAA;IACA,uBAAA;IACA,kBAAA;EApCD;AACF;AAuCC;EACC,aAAA;AArCF;AAwCC;EACC,cAAA;EACA,eAAA;EACA,YAAA;AAtCF;AAuCE;EACC,gBAAA;AArCH;AAwCE;EACC,kBAAA;AAtCH;AAyCC;EACC,yBAAA;EACA,mBAAA;EACA,iBAAA;EACA,wBAAA;EACA,gBAAA;EACA,4CAAA;EACA,iBAAA;EACA,gBAAA;EAEA,uBAAA;AAxCF;AAyCE;EACC,+CAAA;EAEA,eAAA;EACA,iBAAA;EACA,SAAA;EACA,iCAAA;EAEA,sBAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;EACA,uBAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;AAzCH;AA2CE;;EAEC,YAAA;EACA,WAAA;EACA,iBAAA;AAzCH;AA4CE;EACC,wBAAA;EACA,oCAAA;AA1CH;AA2CG;EACC,YAAA;AAzCJ;AA4CG;EACC,8BAAA;AA1CJ;;AA+CA;EACC,4BAAA;EACA,WAAA;AA5CD;ACvQE;EDiTF;IAIE,4BAAA;IACA,WAAA;EA1CA;AACF;;AA4CA;EACC,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,sBAAA;AAzCD;AA2CC;EAEO,SAAA;AA1CR;AA6CQ;EACI,eAAA;EACA,iCAAA;EACT,0BAAA;AA3CH;AA6CQ;EACI,iCAAA;EACA,eAAA;EACA,gBAAA;AA3CZ;;AA+CA;EACC,WAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;EACA,UAAA;EACA,iBAAA;EACA,eAAA;EACA,UAAA;EACA,WAAA;EACA,iEAAA;EACA,2DAAA;EACA,6BAAA;EACA,4BAAA;AA5CD;AA6CE;EACA,YAAA;EACA,UAAA;EACA,iBAAA;AA3CF;;AA8CC;EACA,aAAA;EACG,uBAAA;EACA,iBAAA;AA3CJ;;AA8CC;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AA3CD;;AA8CC;EACC,WAAA;AA3CF;;AA8CC;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,uBAAA;AA3CD;AA4CC;EACC,eAAA;EACA,gBAAA;AA1CF;AA4CC;EACC,+BAAA;AA1CF","sourcesContent":["@import '../../../theme/mixins';\n\n$container_padding_top: 30px;\n$order_basket_block_width: 450px;\n.main_row {\n\theight: 100%;\n  \n\t// @include tablet {\n\t//   height: 90%;\n\t// }\n  \n\t.category_col {\n\t\tbackground: #F3F3F3;\n\t  .category_item {\n\t\tdisplay: flex;\n\t\tjustify-content: flex-start;\n\t\talign-items: center;\n\t\tpadding: 10px 5px 10px 10px;\n\t\tmargin-top: 1.5px;\n  \n\t\n  \n\t\tbackground: #F3F3F3;\n\t\tborder-radius: 0px;\n  \n\t\ttransition: all 0.3s;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: flex-start;\n\t\tborder-bottom: 1.5px solid #4F614F1A;\n\t\tion-img {\n\t\t\twidth: 60px;\n\t\t\tmargin-right: 10px;\n\t\t}\n\t\th3 {\n\t\t\tfont-family: AppFontBold, sans-serif;\n\t\t\tfont-size: 14px;\n\t\t\tcolor: var(--ion-color-secondary);\n\t\t}\n\t\n\t\t&:first-of-type {\n\t\t  margin-top: 0px;\n\t\t}\n  \n\t\t&.selected {\n\t\t  background: var(--ion-color-primary);\n\t\t  color: #fff;\n\t\t  h3 {\n\t\t\tcolor: white;\n\t\t  }\n\t\t}\n\t  }\n\t}\n\t.border_top_line {\n\t  width: 100%;\n\t  height: 3px;\n\t  background: #d9d9d9;\n\t}\n\t.category_name {\n\t  font-family: AppFontMedium;\n\t  font-size: 17px;\n\t  letter-spacing: 0em;\n\t  text-align: left;\n  \n\t  padding: 30px 0px 20px 7px;\n\t}\n  \n\t.item_row {\n\t  margin: 0 10px;\n\t}\n  \n\t.catalog_col {\n\t  position: relative;\n\t  overflow: hidden;\n\t  padding-top: 0;\n  \n\t\n\t}\n  }\n  \n.search_col {\n\twidth: 100%;\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: center;\n\tion-searchbar {\n\n\t\t--box-shadow: 0px 0px 42px 0px #00000012;\n\t\t--border-radius: 10px;\n\t}\n\t.open_filters {\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\twidth: 42px;\n\t\theight: 42px;\n\t\tborder-radius: 10px;\n\t\tbox-shadow: 0px 0px 42px 0px #00000012;\n\t\tion-icon {\n\t\t\tzoom: 1.3;\n\t\t}\n\t}\n}\n\n\n.order_basket_block {\n\tposition: absolute;\n\tz-index: 20;\n\theight: 99%;\n\n\twidth: $order_basket_block_width;\n\tbackground: #fbfbfb;\n\t// box-shadow: 0px 4px 4px 0px #00000040;\n\n\tright: calc($order_basket_block_width * (-1));\n\ttop: -1px;\n\n\ttransition: right 0.3s;\n\n\t&.open {\n\t  right: 0;\n\t  -webkit-box-shadow: -26px 11px 79px -10px rgba(149, 149, 149, 1);\n\t  -moz-box-shadow: -26px 11px 79px -10px rgba(149, 149, 149, 1);\n\t  box-shadow: -26px 11px 79px -10px rgba(149, 149, 149, 1);\n\t}\n\n\t.order_basket_header {\n\t  .close_basket_col {\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\tbackground: transparent;\n\t\tpadding-left: 20px;\n\n\t\tfont-family: AppFont;\n\t\tfont-size: 14px;\n\t\tletter-spacing: 0em;\n\t\tcolor: var(--ion-color-black);\n\t\tbackground: #f9f9f9;\n\t  }\n\n\t  .close_basket_img_col {\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\tbackground: #d9d9d9;\n\t\tpadding: 0 16.5px;\n\t\theight: 55px;\n\t\twidth: 55px !important;\n\t\t.close_basket_img {\n\t\t  height: 14px;\n\t\t  width: 14px;\n\t\t}\n\t  }\n\t}\n\n\n  }\n  .footer-btn-desktop {\n\tposition: absolute;\n\tbottom: 35px;\n\tleft: 50%;\n\ttransform: translateX(-50%);\n\twidth: 40%;\n\ttext-align: center;\n\tdisplay: flex;\n\tjustify-content: center;\n\tion-button {\n\t  width: 100%;\n\t}\n  }\n  .order_basket_block {\n\tposition: absolute;\n\tz-index: 20;\n\theight: 99%;\n\n\twidth: $order_basket_block_width;\n\tbackground: #fbfbfb;\n\t// box-shadow: 0px 4px 4px 0px #00000040;\n\n\tright: calc($order_basket_block_width * (-1));\n\ttop: -1px;\n\n\ttransition: right 0.3s;\n\n\t&.open {\n\t  right: 0;\n\t  -webkit-box-shadow: -26px 11px 79px -10px rgba(149, 149, 149, 1);\n\t  -moz-box-shadow: -26px 11px 79px -10px rgba(149, 149, 149, 1);\n\t  box-shadow: -26px 11px 79px -10px rgba(149, 149, 149, 1);\n\t}\n\n\t.order_basket_header {\n\t  .close_basket_col {\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\tbackground: transparent;\n\t\tpadding-left: 20px;\n\n\t\tfont-family: AppFont;\n\t\tfont-size: 14px;\n\t\tletter-spacing: 0em;\n\t\tcolor: var(--ion-color-black);\n\t\tbackground: #f9f9f9;\n\t  }\n\n\t  .close_basket_img_col {\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\tbackground: #d9d9d9;\n\t\tpadding: 0 16.5px;\n\t\theight: 55px;\n\t\twidth: 55px !important;\n\t\t.close_basket_img {\n\t\t  height: 14px;\n\t\t  width: 14px;\n\t\t}\n\t  }\n\t}\n  }\n  .order_list_row {\n\theight: 100%;\n\tdisplay: flex;\n\tapp-order-content {\n\t\twidth: 100%;\n\t}\n  }\n  .category-list {\n\tdisplay: flex;\n\toverflow: auto;\n\tscroll-behavior: smooth;\n\t-ms-overflow-style: none;\n\tpadding: 10px 0px 0px 10px;\n\tscrollbar-width: none; /* Firefox */\n\t@include desktop {\n\t\theight: 90px;\n\t\tflex-grow: 1;\n\t\t> ion-chip {\n\t\t\toverflow: unset;\n\t\t\tdisplay: flex;\n\t\t\tflex-grow: 1 !important;\n\t\t\tpadding: 12px 16px;\n\t\t}\n\t}\n\n\t&::-webkit-scrollbar {\n\t\tdisplay: none;\n\t}\n\n\t.category {\n\t\tflex: 0 0 auto;\n\t\tmargin: 8px 3px;\n\t\theight: auto;\n\t\t&:first-child {\n\t\t\tmargin-left: 0px;\n\t\t}\n\n\t\t&:last-child {\n\t\t\tmargin-right: 15px;\n\t\t}\n\t}\n\tion-chip {\n\t\t--background: transparent;\n\t\tborder-radius: 16px;\n\t\tbackground: white;\n\t\ttransition: 200ms linear;\n\t\tmin-width: 104px;\n\t\tborder: 1.5px solid var(--ion-color-primary);\n\t\tpadding: 10px 8px;\n\t\tmin-height: 54px;\n\n\t\tjustify-content: center;\n\t\tp {\n\t\t\tfont-family: AppFontBold, sans-serif !important;\n\t\n\t\t\tfont-size: 16px;\n\t\t\tline-height: 14px;\n\t\t\tmargin: 0;\n\t\t\tcolor: var(--ion-color-secondary);\n\t\n\t\t\tword-break: break-word;\n\t\t\tdisplay: -webkit-box;\n\t\t\t-webkit-line-clamp: 1;\n\t\t\t-webkit-box-orient: vertical;\n\t\t\toverflow: hidden;\n\t\t\ttext-overflow: ellipsis;\n\t\t\tmargin-top: 0px;\n\t\t\tmargin-bottom: 0px;\n\t\t\ttext-align: center;\n\t\t}\n\t\tion-icon,\n\t\tion-img {\n\t\t\theight: 31px;\n\t\t\twidth: 31px;\n\t\t\tmargin-right: 5px;\n\t\t}\n\t\n\t\t&.selected {\n\t\t\ttransition: 200ms linear;\n\t\t\tbackground: var(--ion-color-primary);\n\t\t\tp {\n\t\t\t\tcolor: white\n\t\t\t}\n\t\t\t\n\t\t\tion-icon {\n\t\t\t\tfill: var(--ion-color-primary);\n\t\t\t}\n\t\t}\n\t}\n}\n.more {\n\tmin-height: 100px !important;\n\twidth: 100%;\n\t@include mobile {\n\t\tmin-height: 250px !important;\n\t\twidth: 100%;\n\t}\n}\n.venue_info_block {\n\tdisplay: flex;\n\talign-items: flex-start;\n\tjustify-content: space-between;\n\tpadding: 20px 20px 0px;\n\n\tion-icon {\n        // margin-right: 10px;\n        zoom: 1.2;\n    }\n    div {\n        h3 {\n            font-size: 16px;\n            color: var(--ion-color-secondary);\n\t\t\ttext-transform: capitalize;\n        }\n        p {\n            color: var(--ion-color-secondary);\n            font-size: 14px;\n            padding-top: 5px;\n        }\n    }\n}\n.filters_section {\n\tz-index: 99;\n\tposition: absolute;\n\tbottom: 0px;\n\tleft: 0px;\n\tright: 0px;\n\tbackground: white;\n\tmin-height: 0px;\n\topacity: 0;\n\tz-index: -1;\n\ttransition: min-height 0.3s ease-in-out, opacity 0.3s ease-in-out;\n\tbox-shadow: 0px 0px 20px 0px #4F614F26;\n\tborder-top-right-radius: 16px;\n\tborder-top-left-radius: 16px;\n \t&.show-filters{\n\t\tz-index: 999;\n\t\topacity: 1;\n\t\tmin-height: 200px;\n\t}\n }\n .filter-toggle {\n\tdisplay: flex;\n    justify-content: center;\n    padding: 12px 0px;\n\n }\n .no_items {\n\twidth: 100%;\n\theight: 70vh;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n }\n .bsg-category-nav {\n\tbutton {\n\t\twidth: 100%;\n\t}\n }\n .item-for-showing {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tbackground: transparent;\n\tion-img {\n\t\tmax-width: 50px;\n\t\tmax-height: 50px;\n\t}\n\t&.selected {\n\t\tcolor: var(--ion-color-primary);\n\t}\n }","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
